import {Pipe, PipeTransform} from '@angular/core';
import {IGNORED_CONTENT_KEYS} from 'shared/defaults';

@Pipe({name: 'FilterEmptyAndIgnoredFields'})
export class FilterEmptyAndIgnoredFieldsPipe implements PipeTransform {
	constructor() {}
	transform(input: any[], all = false): any[] {
		const filterIgnored = (v: any) => !IGNORED_CONTENT_KEYS.includes(v.key);
		if (!Array.isArray(input)) {
			return null;
		}
		const res = all ? input : input.filter(filterIgnored);
		return res.filter(() => res.map(({value}) => value).filter(f => f).length);
	}
}
